// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { stimulusApplication as application } from "packages/web"

import CheckoutComponent__CheckoutComponentController from "./checkout_component/checkout_component_controller"
application.register("checkout-component", CheckoutComponent__CheckoutComponentController)
